module.exports = __webpack_public_path__ + "img/3572170410.72170410.png";